import { useCustomerDetailPageContext } from '../datacontroller/CustomerDetailPageContext';
import Divider from '@/common/view/Divider';
import { CustomerInfoRow } from './CustomerInfoRow';

export const CustomerRightInfoView = () => {
  const { customerDetail } = useCustomerDetailPageContext();

  return (
    <div className="rounded-lg bg-typeb-grayWhite p-5 flex-1 flex flex-col gap-3">
      <CustomerInfoRow label="첫 가입/구매일자" value={customerDetail?.first_purchase_date} />
      <CustomerInfoRow label="마지막 구매일자" value={customerDetail?.last_purchase_date} />
      <CustomerInfoRow
        label="마지막 구매 후 경과일"
        value={
          customerDetail?.days_since_last_purchase != null ? `${customerDetail.days_since_last_purchase}일` : undefined
        }
      />
      <CustomerInfoRow
        label="마지막 구매매장"
        value={
          customerDetail?.last_purchase_department_name
            ? `${customerDetail.last_purchase_department_name} 매장`
            : undefined
        }
      />
      <CustomerInfoRow
        label="총 구매횟수"
        value={
          customerDetail?.purchase_count_total != null ? `${customerDetail.purchase_count_total.toLocaleString()}회` : undefined
        }
      />
      <CustomerInfoRow
        label="총 구매금액"
        value={
          customerDetail?.purchase_amount_total != null ? `${customerDetail.purchase_amount_total.toLocaleString()}원` : undefined
        }
      />
      <CustomerInfoRow label="CV 고객단계" value={customerDetail?.cv_model_name} />
      <Divider size="small" />
      <CustomerInfoRow label="재구매주기 도래 상품" value={customerDetail?.repurchase_due_product_names} />
    </div>
  );
};
